import e from "../managers/braze-instance.js";
export function requestImmediateDataFlush(t) {
  if (!e.X()) return;
  const r = e.cr();
  r && r.requestImmediateDataFlush(t);
}
